import {
    FiInputMaskBase,
    getEmptyMaskValue,
    FiInputMaskValue,
} from './input-mask-base';

const ZIPCODE_SHORT_FORMAT = '_____';
const ZIPCODE_LONG_FORMAT = '_____-____';

export class USZipcodeInputMask extends FiInputMaskBase {
    getValue(value: string): FiInputMaskValue {
        const maskValue = getEmptyMaskValue();

        const format =
            value.length > 5 ? ZIPCODE_LONG_FORMAT : ZIPCODE_SHORT_FORMAT;

        maskValue.filled = value;
        maskValue.placeholder = format.substring(value.length);

        return maskValue;
    }
}
